// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"ModalShare_modalHeader__CQDfM","modalContent":"ModalShare_modalContent__tKOgJ","boxImageIconShare":"ModalShare_boxImageIconShare__32fCo"};